<template>
  <div>
    <transition name="fade">
      <div v-if="open" class="modal__wrapper">
        <div class="modal__overlay" @click="handleClose"></div>

        <div class="modal modal--reverse-logistic">
          <div class="modal-v2__header" style="margin-top: 40px;">
            <h2 class="mb-6">{{ title }}</h2>

            <button class="closeModal mt-2" @click="handleClose">
              <svg class="ico" style="stroke: #0550a0; width: 16px; height: 16px;">
                <use xlink:href="/images/svg-symbols.svg#close"></use>
              </svg>
            </button>
          </div>

          <div class="modal__content font-lato">
            <p v-if="error" class="mt-0">
              Nem todos os seus códigos de rastreio foram gerados.
              Confira o que deu errado na página <strong>Meus Envios</strong>.
            </p>

            <p v-else class="mt-0">
              Para enviar uma logística reversa, seu cliente não precisa imprimir outra etiqueta.
              Basta utilizar o código de rastreio enviado no e-mail ou em painel
              <strong>Meus Envios > Rastreios</strong>.
            </p>

            <p>Veja como encontrar o código pelo painel:</p>

            <div class="text-center px-4">
              <img
                src="/images/reverse-logistic/how-to-find-code.png"
                title="Encontrado apenas em envios identificados como Logística Reversa"
                alt="Encontrado apenas em envios identificados como Logística Reversa"
                class="max-w-full"
              />
            </div>
          </div>

          <div class="modal__footer">
            <button
              v-if="!generated && !error"
              class="mui-button mui-button--minimal"
              @click="reject"
            >
              <span>Cancelar</span>
            </button>

            <button
              type="button"
              class="mui-button mui-button--primary"
              :class="{ 'btnBorder--loading': generating }"
              @click="handleClick"
            >
              {{ buttonText }}
            </button>
          </div>
        </div>
      </div>
    </transition>

    <toasts ref="toasts" :timeout="5000" />
  </div>
</template>

<script>
// DEPENDENCIES
import Broadcast from 'commons/js/Broadcast';

// UTILS
import { $post } from 'commons/js/utils/api';

// COMPONENTS
import Toasts from 'commons/js/components/atoms/StackedToast';

export default {
  components: {
    Toasts,
  },

  data() {
    return {
      open: false,
      error: false,
      confirm: null,
      reject: null,
      understood: null,
      generating: false,
      generated: false,
    };
  },

  computed: {
    title() {
      if (this.error) return 'Erro ao gerar o código';

      if (this.generated) {
          return 'O código de rastreio foi gerado';
      } else {
          return 'Postagem de Logística Reversa';
      }
    },
    buttonText() {
      if (this.generating) {
        return 'Gerando...';
      }

      if (this.generated || this.error) {
        return 'Entendi';
      }

      return 'Gerar código';
    },
  },

  async created() {
    const channel = Broadcast.user(MEConfig.get('user.id'));

    channel.listen('.tag.done', this.handleAllETicketsGenerated);
  },

  methods: {
    reset() {
      this.open = false;
      this.error = false;
      this.confirm = null;
      this.reject = null;
      this.understood = null;
      this.generating = false;
      this.generated = false;
    },
    getOrdersIds(orders) {
      return orders.map(({ id }) => id);
    },
    async generateETicket(orders) {
      this.generating = true;

      const { error } = await $post('/api/v2/me/shipment/tag/generate', {
        orders: this.getOrdersIds(orders),
      });

      if (error) {
        this.generating = false;

        const content = `
          <div class="mr-8">
            <p><strong>Erro ao gerar código</strong></p>
            <p>Por favor, tente novamente...</p>
          </div>
        `;

        this.$refs.toasts.createToast(content, 'danger');
      }
    },
    generate(orders) {
      this.open = true;

      return new Promise((resolve) => {
        this.confirm = async () => {
          await this.generateETicket(orders);

          this.understood = () => {
            resolve(true);

            this.reset();
          };
        };

        this.reject = () => {
          resolve(false);

          this.reset();
        };
      });
    },
    inform() {
      this.generated = true;
      this.open = true;
      this.understood = this.reset;
    },
    handleClose() {
      return this.generated ? this.understood() : this.reject();
    },
    handleClick() {
      return this.generated || this.error ? this.understood() : this.confirm();
    },
    handleAllETicketsGenerated({ orders, hasError }) {
      this.generating = false;

      if (hasError) {
        this.error = true;

        return;
      }

      this.$emit('generated', orders);

      this.generated = true;
    },
  },
}
</script>
